exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-dark[data-v-62de2e97] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n.monospace-input[data-v-62de2e97] {\n  font-family: monospace;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62de2e97","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/group-settlement/register-group-settlement/RegisterGroupSettlement.vue
// module id = 676
// module chunks = 1